import Progress from 'antd/lib/progress';
import { theme } from 'antd/lib';
import { useImportContext } from '..';
import './ImportProgress.css';

export const ImportProgress = () => {
    const { token: themeColors } = theme.useToken();
    const {
        importProgress: { imported, failed, total },
    } = useImportContext();

    if (total === 0) {
        return <div className="import-progress"></div>;
    }

    let progress = +(((imported + failed) / total) * 100).toFixed(1);
    let status: 'exception' | 'success' | 'active' = progress === 100 ? (total === failed ? 'exception' : 'success') : 'active';

    return (
        <div className="import-progress" key="import-progress">
            <Progress percent={progress} size="small" strokeColor={themeColors.colorPrimary} status={status} />
        </div>
    );
};
